import CanvasLightTheme from 'foundations-theming-base/stable/canvas/light/theme';
import TrellisLightTheme from 'foundations-theming-base/stable/trellis/light/theme';
import { getDeployedTheme } from '../../utils/getDeployedTheme';
import { Metrics } from '../../utils/metrics';
import { getWindow } from '../../utils/utils';
import devLogger from 'react-utils/devLogger';
import { applyThemeOverrides } from '../../utils/dev-overrides';

// these are used in foundations-components directly, so we need to keep them here for now
export const FLASH_TOKENS_STORAGE_KEY = 'trellis:flash-unsafe-tokens';
export const FLASH_CSS_VAR = '--trellis-flash-token';
export function trackTheme(themeName, themeMode) {
  try {
    Metrics.counter('theme', {
      themeName,
      themeMode
    }).increment();
  } catch (e) {
    // do nothing
  }
}
export const getDefaultTheme = () => {
  return CanvasLightTheme;
};
function getBuiltinTheme(themeName) {
  return themeName === 'trellis' ? TrellisLightTheme : CanvasLightTheme;
}
function getWindowTheme(themeSettings) {
  var _window$name, _window$location$path, _window$location;
  const window = getWindow();
  const accessor = `${themeSettings.themeName}-${themeSettings.themeMode}`;
  if (window.__hubspotTheme && window.__hubspotTheme[accessor]) {
    return window.__hubspotTheme[accessor];
  }
  Metrics.counter('missing-window-theme', {
    themeName: themeSettings.themeName,
    themeMode: themeSettings.themeMode,
    windowName: (_window$name = window.name) !== null && _window$name !== void 0 ? _window$name : '',
    windowPathname: (_window$location$path = (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) !== null && _window$location$path !== void 0 ? _window$location$path : ''
  }).increment();
  return undefined;
}
export function isSyncThemeSettings(themeSettings) {
  const isSyncVersion = themeSettings.themeVersion.type === 'default';

  // themes we do not code-split
  const isSyncTheme = themeSettings.themeMode === 'light' && (themeSettings.themeName === 'canvas' || themeSettings.themeName === 'trellis');
  return isSyncVersion && isSyncTheme;
}

/**
 * We never want to block rendering on loading the theme, so we always initially try to get the theme synchronously
 * and then load it asynchronously if the settings indicate we should.
 */
function getThemeSync(themeSettings) {
  let theme = getBuiltinTheme(themeSettings.themeName);
  const maybeWindowTheme = getWindowTheme(themeSettings);
  if (maybeWindowTheme) {
    theme = maybeWindowTheme;
  }
  return theme;
}
export function getThemeToProvideSync(themeSettings) {
  const theme = getThemeSync(themeSettings);
  return applyThemeOverrides(theme, themeSettings.themeOverrides);
}
export async function getThemeToProvide(themeSettings) {
  var _theme;
  const {
    themeVersion,
    themeOverrides
  } = themeSettings;
  let theme = undefined;
  if (themeVersion.type === 'default') {
    theme = getThemeSync(themeSettings);
  } else {
    theme = await getDeployedTheme(themeSettings);
  }
  if (!theme) {
    devLogger.warn({
      message: `Theme not found for settings: ${JSON.stringify(themeSettings)}. Falling back to default theme.`,
      key: 'theme-provider:theme-not-found'
    });
  }
  const finalTheme = (_theme = theme) !== null && _theme !== void 0 ? _theme : getDefaultTheme();
  return applyThemeOverrides(finalTheme, themeOverrides);
}